// Configuração central do app.
export const STORAGE_VERSION = "1.0.0";
export const APP_NOME = "Portal de Eventos";
export const APP_SUBTITULO = "Painel administrativo";
export const INSTITUICAO = "Colégio Santa Cruz";
